import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { TabsFactory } from '../../factories/TabsFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Tabs extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new TabsFactory
    this.innerComponent = false
  }

  elementIds() {
    return ['id', 'contentId']
  }

  elementClasses() {
    return ['tabsClasses', 'activeClasses','inactiveClasses','contentClasses', 'containerClasses']
  }

  elementStyles() {
    return [
      {id: 'contentId', element: 'id', styles: 'contentStyles', selector: '#', variation: null},
      {element: 'class', styles: 'activeStyles', selector: '.tabs--active', variation: null},
      {element: 'class', styles: 'inactiveStyles', selector: '.tabs--inactive', variation: null},
    ]
  }
  
  elementContents() {
    return []
  }

  info() {
    return {
      name: 'Tabs',
      icon: 'fa-ellipsis-h',
      variations: this.variationsInfo()
    }
  }
}